import { object, string } from 'yup'

export const sendMailSchema = object({
  email: string()
    .required(' ')
    .matches(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, 'Địa chỉ email không hợp lệ')
})
